/**
 * Generic scroll-snap carousel with prev/next arrows.
 * Markup contract: [data-track] scroll container, [data-prev]/[data-next] buttons.
 * Arrow disabled state reflects scroll position.
 */
window.WsCarousel = class WsCarousel extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.track = this.querySelector('[data-track]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    if (!this.track) return;

    this.prevButton?.addEventListener('click', () => this.#scrollBy(-1), { signal });
    this.nextButton?.addEventListener('click', () => this.#scrollBy(1), { signal });
    this.track.addEventListener('scroll', () => this.#updateArrows(), { signal, passive: true });
    window.addEventListener('resize', () => this.#updateArrows(), { signal, passive: true });

    this.#updateArrows();
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  #itemWidth() {
    const item = this.track.firstElementChild;
    if (!item) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  #scrollBy(direction) {
    this.track.scrollBy({ left: direction * this.#itemWidth(), behavior: 'smooth' });
  }

  #updateArrows() {
    if (!this.prevButton && !this.nextButton) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    this.prevButton?.toggleAttribute('disabled', this.track.scrollLeft <= 0);
    this.nextButton?.toggleAttribute('disabled', this.track.scrollLeft >= maxScroll);
  }
}

if (!customElements.get('ws-carousel')) customElements.define('ws-carousel', WsCarousel);
